// @generated by protoc-gen-es v2.11.0 with parameter "target=ts"
// @generated from file gitpod/v1/integration.proto (package gitpod.v1, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import { file_buf_validate_validate } from "../../buf/validate/validate_pb";
import { file_gitpod_tools_v1_logfields } from "../tools/v1/logfields_pb";
import type { PaginationRequest, PaginationResponse } from "./pagination_pb";
import { file_gitpod_v1_pagination } from "./pagination_pb";
import { file_gnostic_openapi_v3_annotations } from "../../gnostic/openapi/v3/annotations_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file gitpod/v1/integration.proto.
 */
export const file_gitpod_v1_integration: GenFile = /*@__PURE__*/
  fileDesc("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", [file_buf_validate_validate, file_gitpod_tools_v1_logfields, file_gitpod_v1_pagination, file_gnostic_openapi_v3_annotations]);

/**
 * IntegrationDefinition defines a service that can be integrated with
 * (e.g. Linear, GitHub, etc.)
 *
 * @generated from message gitpod.v1.IntegrationDefinition
 */
export type IntegrationDefinition = Message<"gitpod.v1.IntegrationDefinition"> & {
  /**
   * id is the unique identifier for this integration definition
   *
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * name is the human-readable name for this integration type
   *
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * description provides a human-readable description of the integration
   *
   * @generated from field: string description = 3;
   */
  description: string;

  /**
   * icon_url is the URL for this integration's icon
   *
   * @generated from field: string icon_url = 4;
   */
  iconUrl: string;

  /**
   * capabilities defines what this integration can do
   *
   * @generated from field: gitpod.v1.IntegrationCapabilities capabilities = 5;
   */
  capabilities?: IntegrationCapabilities;

  /**
   * auth defines the authentication requirements for this integration
   *
   * @generated from field: gitpod.v1.IntegrationAuthentication auth = 6;
   */
  auth?: IntegrationAuthentication;

  /**
   * host is the hostname for this integration (e.g., "linear.app")
   *
   * @generated from field: string host = 7;
   */
  host: string;

  /**
   * experimental indicates if this integration is experimental and requires feature flag
   *
   * @generated from field: bool experimental = 8;
   */
  experimental: boolean;

  /**
   * categories classifies this integration for filtering and display
   *
   * @generated from field: repeated gitpod.v1.IntegrationCategory categories = 9;
   */
  categories: IntegrationCategory[];
};

/**
 * Describes the message gitpod.v1.IntegrationDefinition.
 * Use `create(IntegrationDefinitionSchema)` to create a new message.
 */
export const IntegrationDefinitionSchema: GenMessage<IntegrationDefinition> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_integration, 0);

/**
 * IntegrationCapabilities defines what an integration can do
 *
 * @generated from message gitpod.v1.IntegrationCapabilities
 */
export type IntegrationCapabilities = Message<"gitpod.v1.IntegrationCapabilities"> & {
  /**
   * mcp configuration for Model Context Protocol support
   *
   * @generated from field: gitpod.v1.IntegrationMCPCapability mcp = 1;
   */
  mcp?: IntegrationMCPCapability;

  /**
   * context_parsing configuration for context parsing support
   *
   * @generated from field: gitpod.v1.IntegrationContextParsingCapability context_parsing = 2;
   */
  contextParsing?: IntegrationContextParsingCapability;

  /**
   * source_code_access configuration for source code access support
   *
   * @generated from field: gitpod.v1.IntegrationSourceCodeAccessCapability source_code_access = 3;
   */
  sourceCodeAccess?: IntegrationSourceCodeAccessCapability;

  /**
   * login configuration for login/authentication support
   *
   * @generated from field: gitpod.v1.IntegrationLoginCapability login = 4;
   */
  login?: IntegrationLoginCapability;

  /**
   * agent_client configuration for agent client functionality support
   *
   * @generated from field: gitpod.v1.IntegrationAgentClientCapability agent_client = 5;
   */
  agentClient?: IntegrationAgentClientCapability;

  /**
   * scm_pr_events indicates the integration can act as a source of PR events
   * for automation triggers (e.g., pull_request opened/updated webhooks).
   *
   * @generated from field: gitpod.v1.IntegrationScmPrEventsCapability scm_pr_events = 6;
   */
  scmPrEvents?: IntegrationScmPrEventsCapability;
};

/**
 * Describes the message gitpod.v1.IntegrationCapabilities.
 * Use `create(IntegrationCapabilitiesSchema)` to create a new message.
 */
export const IntegrationCapabilitiesSchema: GenMessage<IntegrationCapabilities> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_integration, 1);

/**
 * IntegrationMCPCapability defines Model Context Protocol capability
 *
 * @generated from message gitpod.v1.IntegrationMCPCapability
 */
export type IntegrationMCPCapability = Message<"gitpod.v1.IntegrationMCPCapability"> & {
  /**
   * url is the remote server URL for the MCP server
   *
   * @generated from field: string url = 1;
   */
  url: string;
};

/**
 * Describes the message gitpod.v1.IntegrationMCPCapability.
 * Use `create(IntegrationMCPCapabilitySchema)` to create a new message.
 */
export const IntegrationMCPCapabilitySchema: GenMessage<IntegrationMCPCapability> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_integration, 2);

/**
 * IntegrationContextParsingCapability defines context parsing capability
 *
 * Additional context parsing configuration can be added here
 *
 * @generated from message gitpod.v1.IntegrationContextParsingCapability
 */
export type IntegrationContextParsingCapability = Message<"gitpod.v1.IntegrationContextParsingCapability"> & {
};

/**
 * Describes the message gitpod.v1.IntegrationContextParsingCapability.
 * Use `create(IntegrationContextParsingCapabilitySchema)` to create a new message.
 */
export const IntegrationContextParsingCapabilitySchema: GenMessage<IntegrationContextParsingCapability> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_integration, 3);

/**
 * IntegrationSourceCodeAccessCapability defines source code access capability
 *
 * Additional source code access configuration can be added here
 *
 * @generated from message gitpod.v1.IntegrationSourceCodeAccessCapability
 */
export type IntegrationSourceCodeAccessCapability = Message<"gitpod.v1.IntegrationSourceCodeAccessCapability"> & {
};

/**
 * Describes the message gitpod.v1.IntegrationSourceCodeAccessCapability.
 * Use `create(IntegrationSourceCodeAccessCapabilitySchema)` to create a new message.
 */
export const IntegrationSourceCodeAccessCapabilitySchema: GenMessage<IntegrationSourceCodeAccessCapability> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_integration, 4);

/**
 * IntegrationLoginCapability defines login/authentication capability
 *
 * Additional login configuration can be added here
 *
 * @generated from message gitpod.v1.IntegrationLoginCapability
 */
export type IntegrationLoginCapability = Message<"gitpod.v1.IntegrationLoginCapability"> & {
};

/**
 * Describes the message gitpod.v1.IntegrationLoginCapability.
 * Use `create(IntegrationLoginCapabilitySchema)` to create a new message.
 */
export const IntegrationLoginCapabilitySchema: GenMessage<IntegrationLoginCapability> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_integration, 5);

/**
 * IntegrationAgentClientCapability indicates the integration supports agent client functionality.
 * The webhook signing secret is stored in IntegrationProprietaryAppConfig.webhook_secret.
 *
 * Empty - presence of this capability indicates agent client support
 *
 * @generated from message gitpod.v1.IntegrationAgentClientCapability
 */
export type IntegrationAgentClientCapability = Message<"gitpod.v1.IntegrationAgentClientCapability"> & {
};

/**
 * Describes the message gitpod.v1.IntegrationAgentClientCapability.
 * Use `create(IntegrationAgentClientCapabilitySchema)` to create a new message.
 */
export const IntegrationAgentClientCapabilitySchema: GenMessage<IntegrationAgentClientCapability> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_integration, 6);

/**
 * IntegrationScmPrEventsCapability indicates the integration can deliver
 * pull request webhook events (opened, updated, etc.) for automation triggers.
 *
 * Empty - presence of this capability indicates PR event support
 *
 * @generated from message gitpod.v1.IntegrationScmPrEventsCapability
 */
export type IntegrationScmPrEventsCapability = Message<"gitpod.v1.IntegrationScmPrEventsCapability"> & {
};

/**
 * Describes the message gitpod.v1.IntegrationScmPrEventsCapability.
 * Use `create(IntegrationScmPrEventsCapabilitySchema)` to create a new message.
 */
export const IntegrationScmPrEventsCapabilitySchema: GenMessage<IntegrationScmPrEventsCapability> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_integration, 7);

/**
 * IntegrationAuthentication defines authentication requirements and options
 *
 * @generated from message gitpod.v1.IntegrationAuthentication
 */
export type IntegrationAuthentication = Message<"gitpod.v1.IntegrationAuthentication"> & {
  /**
   * requires_auth indicates if authentication is required for this integration
   *
   * @generated from field: bool requires_auth = 1;
   */
  requiresAuth: boolean;

  /**
   * api_key configuration if API key authentication is supported
   *
   * @generated from field: gitpod.v1.IntegrationAPIKeyConfig api_key = 2;
   */
  apiKey?: IntegrationAPIKeyConfig;

  /**
   * oauth configuration if OAuth authentication is supported
   *
   * @generated from field: gitpod.v1.IntegrationOAuthConfig oauth = 3;
   */
  oauth?: IntegrationOAuthConfig;

  /**
   * proprietary configuration if supported
   *
   * @generated from field: gitpod.v1.IntegrationProprietaryAppConfig proprietary_app = 4;
   */
  proprietaryApp?: IntegrationProprietaryAppConfig;
};

/**
 * Describes the message gitpod.v1.IntegrationAuthentication.
 * Use `create(IntegrationAuthenticationSchema)` to create a new message.
 */
export const IntegrationAuthenticationSchema: GenMessage<IntegrationAuthentication> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_integration, 8);

/**
 * IntegrationAPIKeyConfig defines API key authentication configuration
 *
 * Additional API key configuration can be added here
 *
 * @generated from message gitpod.v1.IntegrationAPIKeyConfig
 */
export type IntegrationAPIKeyConfig = Message<"gitpod.v1.IntegrationAPIKeyConfig"> & {
};

/**
 * Describes the message gitpod.v1.IntegrationAPIKeyConfig.
 * Use `create(IntegrationAPIKeyConfigSchema)` to create a new message.
 */
export const IntegrationAPIKeyConfigSchema: GenMessage<IntegrationAPIKeyConfig> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_integration, 9);

/**
 * IntegrationOAuthConfig defines OAuth-specific configuration
 *
 * @generated from message gitpod.v1.IntegrationOAuthConfig
 */
export type IntegrationOAuthConfig = Message<"gitpod.v1.IntegrationOAuthConfig"> & {
  /**
   * auth_url is the OAuth authorization endpoint URL
   *
   * @generated from field: string auth_url = 1;
   */
  authUrl: string;

  /**
   * token_url is the OAuth token endpoint URL
   *
   * @generated from field: string token_url = 2;
   */
  tokenUrl: string;

  /**
   * scopes are the OAuth scopes to request
   *
   * @generated from field: repeated string scopes = 3;
   */
  scopes: string[];

  /**
   * client_id is the OAuth client ID (optional if dynamic_registration is enabled)
   *
   * @generated from field: string client_id = 4;
   */
  clientId: string;

  /**
   * client_secret is the OAuth client secret (optional for public clients)
   *
   * @generated from field: string client_secret = 5;
   */
  clientSecret: string;

  /**
   * redirect_url is the OAuth callback/redirect URL
   *
   * @generated from field: string redirect_url = 6;
   */
  redirectUrl: string;

  /**
   * dynamic_registration enables RFC 7591 OAuth 2.0 Dynamic Client Registration.
   * When enabled, client credentials are obtained automatically from the authorization
   * server's registration endpoint (discovered via RFC 8414 metadata).
   * When disabled (default), client_id and client_secret must be pre-configured.
   *
   * @generated from field: bool dynamic_registration = 7;
   */
  dynamicRegistration: boolean;

  /**
   * auth_params are additional query parameters to include in the OAuth
   * authorization URL. Use comma-separated values for multi-value params
   * (e.g., "search:read,chat:write" for Slack's user_scope).
   *
   * @generated from field: map<string, string> auth_params = 8;
   */
  authParams: { [key: string]: string };
};

/**
 * Describes the message gitpod.v1.IntegrationOAuthConfig.
 * Use `create(IntegrationOAuthConfigSchema)` to create a new message.
 */
export const IntegrationOAuthConfigSchema: GenMessage<IntegrationOAuthConfig> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_integration, 10);

/**
 * IntegrationProprietaryAppConfig defines proprietary application integration configuration.
 * Used for app installations that interact with Ona (e.g., GitHub Apps, Linear agent apps).
 *
 * @generated from message gitpod.v1.IntegrationProprietaryAppConfig
 */
export type IntegrationProprietaryAppConfig = Message<"gitpod.v1.IntegrationProprietaryAppConfig"> & {
  /**
   * client_id is the app client ID
   *
   * @generated from field: string client_id = 1;
   */
  clientId: string;

  /**
   * client_secret is the app client secret
   *
   * @generated from field: string client_secret = 2;
   */
  clientSecret: string;

  /**
   * webhook_secret is the secret used to verify webhook signatures from the app provider
   *
   * @generated from field: string webhook_secret = 3;
   */
  webhookSecret: string;

  /**
   * auth_params are additional OAuth authorization parameters to include in the auth URL.
   * Example: {"actor": "app"} for Linear agent installations.
   *
   * @generated from field: map<string, string> auth_params = 4;
   */
  authParams: { [key: string]: string };

  /**
   * app_scopes are OAuth scopes to request when using app installation flows.
   * If not set, falls back to the standard OAuth scopes.
   *
   * @generated from field: repeated string app_scopes = 5;
   */
  appScopes: string[];

  /**
   * token_url is the OAuth token exchange endpoint for app installation flows.
   * If not set, falls back to the standard oauth.token_url.
   * Slack requires a different token endpoint for app-level vs user-level flows.
   *
   * @generated from field: string token_url = 6;
   */
  tokenUrl: string;

  /**
   * app_id is the application identifier assigned by the provider (e.g., GitHub App ID).
   * Used to authenticate as the application itself.
   *
   * @generated from field: string app_id = 7;
   */
  appId: string;

  /**
   * private_key is the PEM-encoded private key used to sign JWTs for app authentication.
   * This is sensitive and will be censored in API responses.
   *
   * @generated from field: string private_key = 8;
   */
  privateKey: string;

  /**
   * app_slug is the URL-friendly identifier assigned by the provider (e.g., GitHub App slug).
   * Used to construct installation URLs like https://github.com/apps/{app_slug}/installations/new.
   *
   * @generated from field: string app_slug = 9;
   */
  appSlug: string;
};

/**
 * Describes the message gitpod.v1.IntegrationProprietaryAppConfig.
 * Use `create(IntegrationProprietaryAppConfigSchema)` to create a new message.
 */
export const IntegrationProprietaryAppConfigSchema: GenMessage<IntegrationProprietaryAppConfig> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_integration, 11);

/**
 * Integration represents an instantiated integration within an organization
 *
 * @generated from message gitpod.v1.Integration
 */
export type Integration = Message<"gitpod.v1.Integration"> & {
  /**
   * id is the unique identifier for this integration instance
   *
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * organization_id is the organization this integration belongs to
   *
   * @generated from field: string organization_id = 2;
   */
  organizationId: string;

  /**
   * integration_definition_id references the integration definition ID.
   * Empty for custom integrations that don't have a backing definition.
   *
   * @generated from field: string integration_definition_id = 3;
   */
  integrationDefinitionId: string;

  /**
   * enabled indicates if this integration is currently enabled
   *
   * @generated from field: bool enabled = 4;
   */
  enabled: boolean;

  /**
   * capabilities defines which capabilities are enabled for this integration
   *
   * @generated from field: gitpod.v1.IntegrationCapabilities capabilities = 5;
   */
  capabilities?: IntegrationCapabilities;

  /**
   * runner_id - if set, restricts integration to specific runner
   *
   * @generated from field: string runner_id = 6;
   */
  runnerId: string;

  /**
   * auth defines which authentication methods are enabled for this integration
   *
   * @generated from field: gitpod.v1.IntegrationAuthentication auth = 7;
   */
  auth?: IntegrationAuthentication;

  /**
   * host is the hostname for this integration (e.g., "linear.app") - optional, inherits from definition
   *
   * @generated from field: string host = 8;
   */
  host: string;

  /**
   * name is the display name. For definition-backed integrations, resolved from the definition.
   *
   * @generated from field: string name = 9;
   */
  name: string;

  /**
   * description of the integration. For definition-backed integrations, resolved from the definition.
   *
   * @generated from field: string description = 10;
   */
  description: string;

  /**
   * icon_url is the URL for this integration's icon. Resolved from the definition for definition-backed integrations.
   *
   * @generated from field: string icon_url = 11;
   */
  iconUrl: string;

  /**
   * categories classifies this integration for filtering and display.
   * For definition-backed integrations, inherits from the definition unless overridden.
   *
   * @generated from field: repeated gitpod.v1.IntegrationCategory categories = 12;
   */
  categories: IntegrationCategory[];
};

/**
 * Describes the message gitpod.v1.Integration.
 * Use `create(IntegrationSchema)` to create a new message.
 */
export const IntegrationSchema: GenMessage<Integration> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_integration, 12);

/**
 * @generated from message gitpod.v1.ListIntegrationDefinitionsRequest
 */
export type ListIntegrationDefinitionsRequest = Message<"gitpod.v1.ListIntegrationDefinitionsRequest"> & {
  /**
   * @generated from field: gitpod.v1.PaginationRequest pagination = 1;
   */
  pagination?: PaginationRequest;
};

/**
 * Describes the message gitpod.v1.ListIntegrationDefinitionsRequest.
 * Use `create(ListIntegrationDefinitionsRequestSchema)` to create a new message.
 */
export const ListIntegrationDefinitionsRequestSchema: GenMessage<ListIntegrationDefinitionsRequest> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_integration, 13);

/**
 * @generated from message gitpod.v1.ListIntegrationDefinitionsResponse
 */
export type ListIntegrationDefinitionsResponse = Message<"gitpod.v1.ListIntegrationDefinitionsResponse"> & {
  /**
   * @generated from field: gitpod.v1.PaginationResponse pagination = 1;
   */
  pagination?: PaginationResponse;

  /**
   * @generated from field: repeated gitpod.v1.IntegrationDefinition definitions = 2;
   */
  definitions: IntegrationDefinition[];
};

/**
 * Describes the message gitpod.v1.ListIntegrationDefinitionsResponse.
 * Use `create(ListIntegrationDefinitionsResponseSchema)` to create a new message.
 */
export const ListIntegrationDefinitionsResponseSchema: GenMessage<ListIntegrationDefinitionsResponse> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_integration, 14);

/**
 * @generated from message gitpod.v1.CreateIntegrationRequest
 */
export type CreateIntegrationRequest = Message<"gitpod.v1.CreateIntegrationRequest"> & {
  /**
   * integration_definition_id references the integration definition ID.
   * Optional for custom integrations — when empty, name and host are required.
   *
   * @generated from field: string integration_definition_id = 1;
   */
  integrationDefinitionId: string;

  /**
   * runner_id is optional and immutable - if provided, restricts integration to specific runner
   *
   * @generated from field: string runner_id = 2;
   */
  runnerId: string;

  /**
   * enabled indicates if this integration is enabled
   *
   * @generated from field: bool enabled = 3;
   */
  enabled: boolean;

  /**
   * capabilities defines which capabilities are enabled for this integration
   *
   * @generated from field: gitpod.v1.IntegrationCapabilities capabilities = 4;
   */
  capabilities?: IntegrationCapabilities;

  /**
   * auth defines which authentication methods are enabled for this integration
   *
   * @generated from field: gitpod.v1.IntegrationAuthentication auth = 5;
   */
  auth?: IntegrationAuthentication;

  /**
   * host is the hostname for this integration (e.g., "linear.app") - optional, derived from MCP URL for custom integrations
   *
   * @generated from field: string host = 6;
   */
  host: string;

  /**
   * name is the display name for custom integrations. Required when integration_definition_id is empty.
   *
   * @generated from field: string name = 7;
   */
  name: string;

  /**
   * description is the description for custom integrations.
   *
   * @generated from field: string description = 8;
   */
  description: string;

  /**
   * categories classifies this integration for filtering and display
   *
   * @generated from field: repeated gitpod.v1.IntegrationCategory categories = 9;
   */
  categories: IntegrationCategory[];
};

/**
 * Describes the message gitpod.v1.CreateIntegrationRequest.
 * Use `create(CreateIntegrationRequestSchema)` to create a new message.
 */
export const CreateIntegrationRequestSchema: GenMessage<CreateIntegrationRequest> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_integration, 15);

/**
 * @generated from message gitpod.v1.CreateIntegrationResponse
 */
export type CreateIntegrationResponse = Message<"gitpod.v1.CreateIntegrationResponse"> & {
  /**
   * @generated from field: gitpod.v1.Integration integration = 1;
   */
  integration?: Integration;
};

/**
 * Describes the message gitpod.v1.CreateIntegrationResponse.
 * Use `create(CreateIntegrationResponseSchema)` to create a new message.
 */
export const CreateIntegrationResponseSchema: GenMessage<CreateIntegrationResponse> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_integration, 16);

/**
 * @generated from message gitpod.v1.GetIntegrationRequest
 */
export type GetIntegrationRequest = Message<"gitpod.v1.GetIntegrationRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;
};

/**
 * Describes the message gitpod.v1.GetIntegrationRequest.
 * Use `create(GetIntegrationRequestSchema)` to create a new message.
 */
export const GetIntegrationRequestSchema: GenMessage<GetIntegrationRequest> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_integration, 17);

/**
 * @generated from message gitpod.v1.GetIntegrationResponse
 */
export type GetIntegrationResponse = Message<"gitpod.v1.GetIntegrationResponse"> & {
  /**
   * @generated from field: gitpod.v1.Integration integration = 1;
   */
  integration?: Integration;
};

/**
 * Describes the message gitpod.v1.GetIntegrationResponse.
 * Use `create(GetIntegrationResponseSchema)` to create a new message.
 */
export const GetIntegrationResponseSchema: GenMessage<GetIntegrationResponse> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_integration, 18);

/**
 * @generated from message gitpod.v1.UpdateIntegrationRequest
 */
export type UpdateIntegrationRequest = Message<"gitpod.v1.UpdateIntegrationRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * enabled indicates if this integration is enabled
   *
   * @generated from field: optional bool enabled = 2;
   */
  enabled?: boolean;

  /**
   * capabilities defines which capabilities are enabled for this integration
   *
   * @generated from field: optional gitpod.v1.IntegrationCapabilities capabilities = 3;
   */
  capabilities?: IntegrationCapabilities;

  /**
   * auth defines which authentication methods are enabled for this integration
   *
   * @generated from field: optional gitpod.v1.IntegrationAuthentication auth = 4;
   */
  auth?: IntegrationAuthentication;

  /**
   * host is the hostname for this integration (e.g., "linear.app") - optional, inherits from definition
   *
   * @generated from field: optional string host = 5;
   */
  host?: string;

  /**
   * name is the display name. Only updatable for custom integrations.
   *
   * @generated from field: optional string name = 6;
   */
  name?: string;

  /**
   * description is the description. Only updatable for custom integrations.
   *
   * @generated from field: optional string description = 7;
   */
  description?: string;

  /**
   * categories classifies this integration for filtering and display
   *
   * @generated from field: repeated gitpod.v1.IntegrationCategory categories = 8;
   */
  categories: IntegrationCategory[];
};

/**
 * Describes the message gitpod.v1.UpdateIntegrationRequest.
 * Use `create(UpdateIntegrationRequestSchema)` to create a new message.
 */
export const UpdateIntegrationRequestSchema: GenMessage<UpdateIntegrationRequest> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_integration, 19);

/**
 * @generated from message gitpod.v1.UpdateIntegrationResponse
 */
export type UpdateIntegrationResponse = Message<"gitpod.v1.UpdateIntegrationResponse"> & {
  /**
   * @generated from field: gitpod.v1.Integration integration = 1;
   */
  integration?: Integration;
};

/**
 * Describes the message gitpod.v1.UpdateIntegrationResponse.
 * Use `create(UpdateIntegrationResponseSchema)` to create a new message.
 */
export const UpdateIntegrationResponseSchema: GenMessage<UpdateIntegrationResponse> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_integration, 20);

/**
 * @generated from message gitpod.v1.DeleteIntegrationRequest
 */
export type DeleteIntegrationRequest = Message<"gitpod.v1.DeleteIntegrationRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;
};

/**
 * Describes the message gitpod.v1.DeleteIntegrationRequest.
 * Use `create(DeleteIntegrationRequestSchema)` to create a new message.
 */
export const DeleteIntegrationRequestSchema: GenMessage<DeleteIntegrationRequest> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_integration, 21);

/**
 * @generated from message gitpod.v1.DeleteIntegrationResponse
 */
export type DeleteIntegrationResponse = Message<"gitpod.v1.DeleteIntegrationResponse"> & {
};

/**
 * Describes the message gitpod.v1.DeleteIntegrationResponse.
 * Use `create(DeleteIntegrationResponseSchema)` to create a new message.
 */
export const DeleteIntegrationResponseSchema: GenMessage<DeleteIntegrationResponse> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_integration, 22);

/**
 * @generated from message gitpod.v1.ListIntegrationsRequest
 */
export type ListIntegrationsRequest = Message<"gitpod.v1.ListIntegrationsRequest"> & {
  /**
   * @generated from field: gitpod.v1.PaginationRequest pagination = 1;
   */
  pagination?: PaginationRequest;
};

/**
 * Describes the message gitpod.v1.ListIntegrationsRequest.
 * Use `create(ListIntegrationsRequestSchema)` to create a new message.
 */
export const ListIntegrationsRequestSchema: GenMessage<ListIntegrationsRequest> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_integration, 23);

/**
 * @generated from message gitpod.v1.ListIntegrationsResponse
 */
export type ListIntegrationsResponse = Message<"gitpod.v1.ListIntegrationsResponse"> & {
  /**
   * @generated from field: gitpod.v1.PaginationResponse pagination = 1;
   */
  pagination?: PaginationResponse;

  /**
   * @generated from field: repeated gitpod.v1.Integration integrations = 2;
   */
  integrations: Integration[];
};

/**
 * Describes the message gitpod.v1.ListIntegrationsResponse.
 * Use `create(ListIntegrationsResponseSchema)` to create a new message.
 */
export const ListIntegrationsResponseSchema: GenMessage<ListIntegrationsResponse> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_integration, 24);

/**
 * @generated from message gitpod.v1.CreateIntegrationDefinitionRequest
 */
export type CreateIntegrationDefinitionRequest = Message<"gitpod.v1.CreateIntegrationDefinitionRequest"> & {
  /**
   * name is the human-readable name for this integration type
   *
   * @generated from field: string name = 1;
   */
  name: string;

  /**
   * description provides a human-readable description of the integration
   *
   * @generated from field: string description = 2;
   */
  description: string;

  /**
   * icon_url is the URL for this integration's icon
   *
   * @generated from field: string icon_url = 3;
   */
  iconUrl: string;

  /**
   * capabilities defines what this integration can do
   *
   * @generated from field: gitpod.v1.IntegrationCapabilities capabilities = 4;
   */
  capabilities?: IntegrationCapabilities;

  /**
   * auth defines the authentication requirements for this integration
   *
   * @generated from field: gitpod.v1.IntegrationAuthentication auth = 5;
   */
  auth?: IntegrationAuthentication;

  /**
   * host is the hostname for this integration (e.g., "linear.app")
   *
   * @generated from field: string host = 6;
   */
  host: string;

  /**
   * experimental indicates if this integration is experimental and requires feature flag
   *
   * @generated from field: bool experimental = 7;
   */
  experimental: boolean;

  /**
   * categories classifies this integration for filtering and display
   *
   * @generated from field: repeated gitpod.v1.IntegrationCategory categories = 8;
   */
  categories: IntegrationCategory[];
};

/**
 * Describes the message gitpod.v1.CreateIntegrationDefinitionRequest.
 * Use `create(CreateIntegrationDefinitionRequestSchema)` to create a new message.
 */
export const CreateIntegrationDefinitionRequestSchema: GenMessage<CreateIntegrationDefinitionRequest> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_integration, 25);

/**
 * @generated from message gitpod.v1.CreateIntegrationDefinitionResponse
 */
export type CreateIntegrationDefinitionResponse = Message<"gitpod.v1.CreateIntegrationDefinitionResponse"> & {
  /**
   * @generated from field: gitpod.v1.IntegrationDefinition definition = 1;
   */
  definition?: IntegrationDefinition;
};

/**
 * Describes the message gitpod.v1.CreateIntegrationDefinitionResponse.
 * Use `create(CreateIntegrationDefinitionResponseSchema)` to create a new message.
 */
export const CreateIntegrationDefinitionResponseSchema: GenMessage<CreateIntegrationDefinitionResponse> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_integration, 26);

/**
 * @generated from message gitpod.v1.GetIntegrationDefinitionRequest
 */
export type GetIntegrationDefinitionRequest = Message<"gitpod.v1.GetIntegrationDefinitionRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;
};

/**
 * Describes the message gitpod.v1.GetIntegrationDefinitionRequest.
 * Use `create(GetIntegrationDefinitionRequestSchema)` to create a new message.
 */
export const GetIntegrationDefinitionRequestSchema: GenMessage<GetIntegrationDefinitionRequest> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_integration, 27);

/**
 * @generated from message gitpod.v1.GetIntegrationDefinitionResponse
 */
export type GetIntegrationDefinitionResponse = Message<"gitpod.v1.GetIntegrationDefinitionResponse"> & {
  /**
   * @generated from field: gitpod.v1.IntegrationDefinition definition = 1;
   */
  definition?: IntegrationDefinition;
};

/**
 * Describes the message gitpod.v1.GetIntegrationDefinitionResponse.
 * Use `create(GetIntegrationDefinitionResponseSchema)` to create a new message.
 */
export const GetIntegrationDefinitionResponseSchema: GenMessage<GetIntegrationDefinitionResponse> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_integration, 28);

/**
 * @generated from message gitpod.v1.UpdateIntegrationDefinitionRequest
 */
export type UpdateIntegrationDefinitionRequest = Message<"gitpod.v1.UpdateIntegrationDefinitionRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * name is the human-readable name for this integration type
   *
   * @generated from field: optional string name = 2;
   */
  name?: string;

  /**
   * description provides a human-readable description of the integration
   *
   * @generated from field: optional string description = 3;
   */
  description?: string;

  /**
   * icon_url is the URL for this integration's icon
   *
   * @generated from field: optional string icon_url = 4;
   */
  iconUrl?: string;

  /**
   * capabilities defines what this integration can do
   *
   * @generated from field: optional gitpod.v1.IntegrationCapabilities capabilities = 5;
   */
  capabilities?: IntegrationCapabilities;

  /**
   * auth defines the authentication requirements for this integration
   *
   * @generated from field: optional gitpod.v1.IntegrationAuthentication auth = 6;
   */
  auth?: IntegrationAuthentication;

  /**
   * host is the hostname for this integration (e.g., "linear.app")
   *
   * @generated from field: optional string host = 7;
   */
  host?: string;

  /**
   * experimental indicates if this integration is experimental and requires feature flag
   *
   * @generated from field: optional bool experimental = 8;
   */
  experimental?: boolean;

  /**
   * categories classifies this integration for filtering and display
   *
   * @generated from field: repeated gitpod.v1.IntegrationCategory categories = 9;
   */
  categories: IntegrationCategory[];
};

/**
 * Describes the message gitpod.v1.UpdateIntegrationDefinitionRequest.
 * Use `create(UpdateIntegrationDefinitionRequestSchema)` to create a new message.
 */
export const UpdateIntegrationDefinitionRequestSchema: GenMessage<UpdateIntegrationDefinitionRequest> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_integration, 29);

/**
 * @generated from message gitpod.v1.UpdateIntegrationDefinitionResponse
 */
export type UpdateIntegrationDefinitionResponse = Message<"gitpod.v1.UpdateIntegrationDefinitionResponse"> & {
  /**
   * @generated from field: gitpod.v1.IntegrationDefinition definition = 1;
   */
  definition?: IntegrationDefinition;
};

/**
 * Describes the message gitpod.v1.UpdateIntegrationDefinitionResponse.
 * Use `create(UpdateIntegrationDefinitionResponseSchema)` to create a new message.
 */
export const UpdateIntegrationDefinitionResponseSchema: GenMessage<UpdateIntegrationDefinitionResponse> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_integration, 30);

/**
 * @generated from message gitpod.v1.DeleteIntegrationDefinitionRequest
 */
export type DeleteIntegrationDefinitionRequest = Message<"gitpod.v1.DeleteIntegrationDefinitionRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;
};

/**
 * Describes the message gitpod.v1.DeleteIntegrationDefinitionRequest.
 * Use `create(DeleteIntegrationDefinitionRequestSchema)` to create a new message.
 */
export const DeleteIntegrationDefinitionRequestSchema: GenMessage<DeleteIntegrationDefinitionRequest> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_integration, 31);

/**
 * @generated from message gitpod.v1.DeleteIntegrationDefinitionResponse
 */
export type DeleteIntegrationDefinitionResponse = Message<"gitpod.v1.DeleteIntegrationDefinitionResponse"> & {
};

/**
 * Describes the message gitpod.v1.DeleteIntegrationDefinitionResponse.
 * Use `create(DeleteIntegrationDefinitionResponseSchema)` to create a new message.
 */
export const DeleteIntegrationDefinitionResponseSchema: GenMessage<DeleteIntegrationDefinitionResponse> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_integration, 32);

/**
 * @generated from message gitpod.v1.ValidateIntegrationRequest
 */
export type ValidateIntegrationRequest = Message<"gitpod.v1.ValidateIntegrationRequest"> & {
  /**
   * @generated from field: string integration_id = 1;
   */
  integrationId: string;
};

/**
 * Describes the message gitpod.v1.ValidateIntegrationRequest.
 * Use `create(ValidateIntegrationRequestSchema)` to create a new message.
 */
export const ValidateIntegrationRequestSchema: GenMessage<ValidateIntegrationRequest> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_integration, 33);

/**
 * @generated from message gitpod.v1.ValidateIntegrationResponse
 */
export type ValidateIntegrationResponse = Message<"gitpod.v1.ValidateIntegrationResponse"> & {
  /**
   * valid is true when all checks pass (convenience field).
   *
   * @generated from field: bool valid = 1;
   */
  valid: boolean;

  /**
   * checks contains the result of every check performed.
   * Passing checks have empty message and action_hint.
   *
   * @generated from field: repeated gitpod.v1.ValidationCheck checks = 2;
   */
  checks: ValidationCheck[];
};

/**
 * Describes the message gitpod.v1.ValidateIntegrationResponse.
 * Use `create(ValidateIntegrationResponseSchema)` to create a new message.
 */
export const ValidateIntegrationResponseSchema: GenMessage<ValidateIntegrationResponse> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_integration, 34);

/**
 * @generated from message gitpod.v1.ValidationCheck
 */
export type ValidationCheck = Message<"gitpod.v1.ValidationCheck"> & {
  /**
   * Which check this result is for.
   *
   * @generated from field: gitpod.v1.ValidationCheck.Check check = 1;
   */
  check: ValidationCheck_Check;

  /**
   * Human-readable description of the problem. Empty when the check passes.
   *
   * @generated from field: string message = 2;
   */
  message: string;

  /**
   * Machine-readable hint the frontend uses to resolve the issue (e.g. "app_installation_oauth").
   * Empty when the check passes or no automated fix is available.
   *
   * @generated from field: string action_hint = 3;
   */
  actionHint: string;

  /**
   * URL to documentation explaining this check failure and resolution steps.
   * Empty when the check passes or no docs exist for this check.
   *
   * @generated from field: string documentation_url = 4;
   */
  documentationUrl: string;
};

/**
 * Describes the message gitpod.v1.ValidationCheck.
 * Use `create(ValidationCheckSchema)` to create a new message.
 */
export const ValidationCheckSchema: GenMessage<ValidationCheck> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_integration, 35);

/**
 * @generated from enum gitpod.v1.ValidationCheck.Check
 */
export enum ValidationCheck_Check {
  /**
   * @generated from enum value: CHECK_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: CHECK_APP_TOKEN = 1;
   */
  APP_TOKEN = 1,

  /**
   * @generated from enum value: CHECK_APP_INSTALLATION = 2;
   */
  APP_INSTALLATION = 2,
}

/**
 * Describes the enum gitpod.v1.ValidationCheck.Check.
 */
export const ValidationCheck_CheckSchema: GenEnum<ValidationCheck_Check> = /*@__PURE__*/
  enumDesc(file_gitpod_v1_integration, 35, 0);

/**
 * IntegrationCategory classifies integrations for filtering and display.
 *
 * @generated from enum gitpod.v1.IntegrationCategory
 */
export enum IntegrationCategory {
  /**
   * @generated from enum value: INTEGRATION_CATEGORY_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: INTEGRATION_CATEGORY_SOURCE_CONTROL = 1;
   */
  SOURCE_CONTROL = 1,

  /**
   * @generated from enum value: INTEGRATION_CATEGORY_COMMUNICATION = 2;
   */
  COMMUNICATION = 2,

  /**
   * @generated from enum value: INTEGRATION_CATEGORY_PROJECT_MANAGEMENT = 3;
   */
  PROJECT_MANAGEMENT = 3,

  /**
   * @generated from enum value: INTEGRATION_CATEGORY_OBSERVABILITY = 4;
   */
  OBSERVABILITY = 4,

  /**
   * @generated from enum value: INTEGRATION_CATEGORY_DATA_ANALYTICS = 5;
   */
  DATA_ANALYTICS = 5,

  /**
   * @generated from enum value: INTEGRATION_CATEGORY_KNOWLEDGE = 6;
   */
  KNOWLEDGE = 6,

  /**
   * @generated from enum value: INTEGRATION_CATEGORY_MCP = 7;
   */
  MCP = 7,
}

/**
 * Describes the enum gitpod.v1.IntegrationCategory.
 */
export const IntegrationCategorySchema: GenEnum<IntegrationCategory> = /*@__PURE__*/
  enumDesc(file_gitpod_v1_integration, 0);

/**
 * @generated from service gitpod.v1.IntegrationService
 */
export const IntegrationService: GenService<{
  /**
   * Lists available integration definitions.
   *
   * Use this method to:
   * - View all available integrations
   * - Check integration capabilities
   * - Discover supported services
   *
   *
   * @generated from rpc gitpod.v1.IntegrationService.ListIntegrationDefinitions
   */
  listIntegrationDefinitions: {
    methodKind: "unary";
    input: typeof ListIntegrationDefinitionsRequestSchema;
    output: typeof ListIntegrationDefinitionsResponseSchema;
  },
  /**
   * Creates a new integration definition.
   * Requires service account authentication.
   *
   * Use this method to:
   * - Add new integration types dynamically
   * - Configure integration capabilities
   * - Set up authentication requirements
   *
   *
   * @generated from rpc gitpod.v1.IntegrationService.CreateIntegrationDefinition
   */
  createIntegrationDefinition: {
    methodKind: "unary";
    input: typeof CreateIntegrationDefinitionRequestSchema;
    output: typeof CreateIntegrationDefinitionResponseSchema;
  },
  /**
   * Gets details about a specific integration definition.
   *
   * Use this method to:
   * - View integration definition configuration
   * - Check supported capabilities
   * - Verify authentication requirements
   *
   *
   * @generated from rpc gitpod.v1.IntegrationService.GetIntegrationDefinition
   */
  getIntegrationDefinition: {
    methodKind: "unary";
    input: typeof GetIntegrationDefinitionRequestSchema;
    output: typeof GetIntegrationDefinitionResponseSchema;
  },
  /**
   * Updates an existing integration definition.
   * Requires service account authentication.
   *
   * Use this method to:
   * - Modify integration capabilities
   * - Update authentication configuration
   * - Change integration metadata
   *
   *
   * @generated from rpc gitpod.v1.IntegrationService.UpdateIntegrationDefinition
   */
  updateIntegrationDefinition: {
    methodKind: "unary";
    input: typeof UpdateIntegrationDefinitionRequestSchema;
    output: typeof UpdateIntegrationDefinitionResponseSchema;
  },
  /**
   * Deletes an integration definition.
   * Requires service account authentication.
   * Fails if any integrations depend on this definition.
   *
   * Use this method to:
   * - Remove unused integration types
   * - Clean up deprecated integrations
   *
   *
   * @generated from rpc gitpod.v1.IntegrationService.DeleteIntegrationDefinition
   */
  deleteIntegrationDefinition: {
    methodKind: "unary";
    input: typeof DeleteIntegrationDefinitionRequestSchema;
    output: typeof DeleteIntegrationDefinitionResponseSchema;
  },
  /**
   * Creates a new integration instance within an organization.
   *
   * Use this method to:
   * - Instantiate an integration for an organization
   * - Configure integration-specific settings
   * - Enable integration capabilities
   *
   *
   * @generated from rpc gitpod.v1.IntegrationService.CreateIntegration
   */
  createIntegration: {
    methodKind: "unary";
    input: typeof CreateIntegrationRequestSchema;
    output: typeof CreateIntegrationResponseSchema;
  },
  /**
   * Gets details about a specific integration instance.
   *
   * Use this method to:
   * - View integration configuration
   * - Check integration status
   * - Verify enabled capabilities
   *
   *
   * @generated from rpc gitpod.v1.IntegrationService.GetIntegration
   */
  getIntegration: {
    methodKind: "unary";
    input: typeof GetIntegrationRequestSchema;
    output: typeof GetIntegrationResponseSchema;
  },
  /**
   * Updates an existing integration instance.
   *
   * Use this method to:
   * - Modify integration settings
   * - Enable/disable capabilities
   * - Change integration status
   *
   *
   * @generated from rpc gitpod.v1.IntegrationService.UpdateIntegration
   */
  updateIntegration: {
    methodKind: "unary";
    input: typeof UpdateIntegrationRequestSchema;
    output: typeof UpdateIntegrationResponseSchema;
  },
  /**
   * Deletes an integration instance.
   *
   * Use this method to:
   * - Remove unused integrations
   * - Clean up configurations
   * - Revoke integration access
   *
   *
   * @generated from rpc gitpod.v1.IntegrationService.DeleteIntegration
   */
  deleteIntegration: {
    methodKind: "unary";
    input: typeof DeleteIntegrationRequestSchema;
    output: typeof DeleteIntegrationResponseSchema;
  },
  /**
   * Lists integration instances for the organization.
   *
   * Use this method to:
   * - View all integrations for an organization
   * - Monitor integration configurations
   *
   *
   * @generated from rpc gitpod.v1.IntegrationService.ListIntegrations
   */
  listIntegrations: {
    methodKind: "unary";
    input: typeof ListIntegrationsRequestSchema;
    output: typeof ListIntegrationsResponseSchema;
  },
  /**
   * Validates an integration's configuration and connectivity.
   *
   * Runs a set of checks (e.g. app token validity) and returns results for each.
   * All checks are always returned; failing checks include a message and an optional action_hint.
   *
   *
   * @generated from rpc gitpod.v1.IntegrationService.ValidateIntegration
   */
  validateIntegration: {
    methodKind: "unary";
    input: typeof ValidateIntegrationRequestSchema;
    output: typeof ValidateIntegrationResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_gitpod_v1_integration, 0);

